import axios from 'axios';
const AthenaGlobalAPI = axios.create({
  baseURL: `${process.env.REACT_APP_ATHENA_GLOBAL_URL}/api/faucet`
})
export const getNonce = async () => AthenaGlobalAPI.get('/nonce')
export const getFaucetSignature = async ({
  signature,
  nonce,
  address
}) => AthenaGlobalAPI.post('/get-faucet-signature', {
  signature,
  nonce,
  address
})